module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.28256/images/pngs/sequence-screen.png"